import { render, staticRenderFns } from "./like-detail.vue?vue&type=template&id=42572b41&scoped=true"
import script from "./like-detail.vue?vue&type=script&lang=js"
export * from "./like-detail.vue?vue&type=script&lang=js"
import style0 from "./like-detail.vue?vue&type=style&index=0&id=42572b41&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42572b41",
  null
  
)

export default component.exports